import { Col, Container, Row } from 'react-bootstrap';
import logo from '../TempEdgeLogoLabel/Logo_Tempedge.png';
import './Footer.css';

const Footer = ({ content }) => {
  return (
    <footer className="footer-tempedge">
      <Container>
        <Row className="justify-content-center">
          <Col xs="auto">
            <div className="footer-inline">
              <img src={logo} alt="TempEdge" className="footer-logo-icon" />
              <div className="footer-copy">{content}</div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
